import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const UserIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        d="M30,26.587 c0-1.684-1.045-3.188-2.629-3.76C25.044,21.986,21.206,21,16,21s-9.044,0.986-11.371,1.827C3.045,23.399,2,24.903,2,26.587V31h28 V26.587z"
        strokeLinejoin="miter"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        d="M16,17L16,17 c-3.866,0-7-3.134-7-7V8c0-3.866,3.134-7,7-7h0c3.866,0,7,3.134,7,7v2C23,13.866,19.866,17,16,17z"
        strokeLinejoin="miter"
      />
    </svg>
  );
};
